import { SDLResolverSpec } from '../utils/SDLContent.utils';
import { getPTZSupported, getSecurity, getSupportedResolutions } from './Additional.mapper';

export const additionalAccessControlInfoSpec = {};

export const additionalIntercomInfoSpec: SDLResolverSpec = {
  certification_level: ['additionalInformation', 'CertificationLevel'],
  initial_release: ['additionalInformation', 'InitialRelease'],
  embedded_camera: ['additionalInformation', 'EmbeddedCamera'],
  dtmf_support: ['additionalInformation', 'DtmfSupport'],
  video_protocol: ['additionalInformation', 'VideoProtocol'],
  cloud_compatible: ['additionalInformation', 'CloudCompatible'],
  ipv6_ready: ['additionalInformation', 'Ipv6Ready'],
  video_codecs: ['additionalInformation', 'VideoCodecs'],
  audio_codecs: ['additionalInformation', 'AudioCodecs'],
  comments: ['additionalInformation', 'Comments'],
};

export const additionalStratocastInfoSpec: SDLResolverSpec = {
  certification_level: ['additionalInformation', 'CertificationLevel'],
  series: ['additionalInformation', 'Series'],
  edge_recording_support: ['additionalInformation', 'EdgeRecordingSupport'],
  nas_recording_support: ['additionalInformation', 'NasRecordingSupport'],
};

export const additionalSaasInfoSpec = {
  audio_type: ['additionalInformation', 'Audio_type'],
  connection_type: ['additionalInformation', 'Connection_type'],
  edge_analytics: ['additionalInformation', 'Edge_analytics'],
  others: ['additionalInformation', 'Others'],
  video_audio_codec: ['additionalInformation', 'video_audio_codec'],
};

export const additionalDefaultInfoSpec: SDLResolverSpec = {
  supported_resolutions: [
    ['additionalInformation', 'SupportedResolutions'],
    [getSupportedResolutions],
  ],
  video_analytics: ['additionalInformation', 'VideoAnalytics'],
  audio_analytics: ['additionalInformation', 'AudioAnalytics'],
  video_attributes: ['additionalInformation', 'VideoAttributes'],
  motion_detection: ['motionDetection'],
  edge_recording: ['additionalInformation', 'Features', 'EdgeRecording'],
  ptz_supported: [['additionalInformation', 'PtzMotorAttributes'], [getPTZSupported]],
  serial_port_support: [['additionalInformation', 'SerialPortTypes'], [], 'No'],
  ipv6_support: ['additionalInformation', 'Features', 'IPv6Support'],
  software_dewarping: ['additionalInformation', 'Features', 'SoftwareDewarping'],
  unit_dewarping: ['additionalInformation', 'Features', 'UnitDewarping'],
  high_frame_rate_capable: [['additionalInformation', 'HighFrameRate'], [], 'No'],
  secure_communication: [['additionalInformation', 'Security'], [getSecurity]],
  connection_type: ['connectionType'],
  comments: ['basicInformation', 'Comments'],
};

export const deviceTypeAdditionalInfoSpecMap: Record<string, SDLResolverSpec> = {
  'access-control': additionalAccessControlInfoSpec,
  intercom: additionalIntercomInfoSpec,
  stratocast: additionalStratocastInfoSpec,
  saas: additionalSaasInfoSpec,
  camera: additionalDefaultInfoSpec,
};
